import React, { useEffect, useState } from "react";
import Colors from "../../../Helper/Colors";
import FormatHelper from "../../../Helper/FormatHelper";
import companyShareIcon from "../../../assets/images/techapp/company-share.png";
import netProfitIcon from "../../../assets/images/techapp/net-profit.png";
import totalCostIcon from "../../../assets/images/techapp/total-cost.png";
import trackingCodeIcon from "../../../assets/images/techapp/tracking-code.png";
import savedBalanceIcon from "../../../assets/images/techapp/saved-balance.png";
import lang from "../lang/lang.json";
import { FiCalendar } from "react-icons/fi";
import { CiCreditCard1 } from "react-icons/ci";
import { FaChartBar, FaHashtag, FaRegUser } from "react-icons/fa";
import { IoMdInformationCircleOutline } from "react-icons/io";

const TransactionactionCard = ({ transaction, index, profileData, collapsedStatus }) => {
  const [collapsed, setCollapsed] = useState(collapsedStatus);

  useEffect(()=>{
    setCollapsed(collapsedStatus);
  }, [collapsedStatus]);

  return (
    <div
      onClick={() => {
        setCollapsed(!collapsed);
      }}
      key={index}
      className="tech-app-transaction-item"
    >
      {/* amount */}
      <div
        style={
          transaction.amount < 0
            ? { backgroundColor: Colors.danger }
            : { backgroundColor: Colors.success }
        }
        className="tech-app-transaction-item-title"
      >
        <span>
          {FormatHelper.toPersianString(
            Math.abs(transaction.amount).toLocaleString()
          )}
        </span>{" "}
        <span>{transaction.currency}</span>{" "}
        {transaction.amount < 0 ? (
          <span>{lang.DEDUCTE_ACCOUNT}</span>
        ) : (
          <span>{lang.CHARGE_ACCOUNT}</span>
        )}
      </div>
      {/* details */}
      <div className="tech-app-transaction-item-detail">
        <span>
          <FiCalendar />
          {FormatHelper.toPersianString(transaction.persian_created_at)}
        </span>
        {!collapsed && (
          <>
            {/* port */}
            {transaction?.port && transaction?.port?.length > 0 && (
              <span>
                <CiCreditCard1 />
                {transaction?.port}
              </span>
            )}
            {/* tracking code */}
            {transaction?.tracking_code &&
              transaction?.tracking_code?.length > 0 && (
                <span title="کد پیگیری">
                  <img
                    style={{ width: "16px", marginLeft: 5 }}
                    src={trackingCodeIcon}
                    alt="tracking code"
                  />
                  {FormatHelper.toPersianString(transaction?.tracking_code)}
                </span>
              )}
            {/* total cost */}
            {transaction?.total_cost && (
              <span title="هزینه کل">
                <img
                  style={{ width: "16px", marginLeft: 5 }}
                  src={totalCostIcon}
                  alt="total cost"
                />
                {FormatHelper.toPersianString(
                  // FormatHelper.numberSeperator(transaction?.total_cost)
                  FormatHelper.numberSeperator(transaction?.cost_announce_detail?.total_cost ?? transaction?.total_cost)
                )}{" "}
                {lang.TOMAN}
              </span>
            )}
            {/* net profit */}
            {transaction?.net_profit && (
              <span title="سود خالص">
                <img
                  style={{ width: "16px", marginLeft: 5 }}
                  src={netProfitIcon}
                  alt="net profit"
                />
                {FormatHelper.toPersianString(
                  FormatHelper.numberSeperator(transaction?.cost_announce_detail?.net_profit ?? transaction?.net_profit)
                )}{" "}
                {lang.TOMAN}
              </span>
            )}
            {/* company share */}
            {transaction?.company_share && (
              <span title="سهم شرکت">
                <img
                  style={{ width: "16px", marginLeft: 5 }}
                  src={companyShareIcon}
                  alt="company share"
                />
                {FormatHelper.toPersianString(
                  FormatHelper.numberSeperator(transaction?.company_share)
                )}{" "}
                {lang.TOMAN}
              </span>
            )}
            {/* saved balance */}
            {transaction?.saved_balance && (
              <span title="مبلغ ذخیره شده">
                <img
                  style={{ width: "16px", marginLeft: 5 }}
                  src={savedBalanceIcon}
                  alt="saved balance"
                />
                {FormatHelper.toPersianString(
                  FormatHelper.numberSeperator(transaction?.saved_balance)
                )}{" "}
                {lang.TOMAN}
              </span>
            )}
            {/* order_user_name */}
            {transaction?.order_user_name &&
              transaction?.order_user_name?.length > 0 && (
                <span>
                  <FaRegUser />
                  {transaction?.order_user_name}
                </span>
              )}
            {/* description */}
            <span>
              <IoMdInformationCircleOutline />
              {transaction?.desc}
            </span>
          </>
        )}
      </div>
      {/* footer */}
      <div className="tech-app-transaction-item-footer">
        {/* balance */}
        {transaction?.balance && (
          <div>
            <span>
              <FaChartBar />
              <span
                style={
                  profileData.balance > 0
                    ? { color: Colors.success }
                    : {
                        color: Colors.danger,
                        direction: "ltr",
                        letterSpacing: "1px",
                      }
                }
              >
                {FormatHelper.toPersianString(
                  transaction.balance.toLocaleString()
                )}
              </span>
              <span
                style={
                  profileData.balance > 0
                    ? { color: Colors.success, marginRight: "2px" }
                    : {
                        color: Colors.danger,
                        direction: "ltr",
                        letterSpacing: "1px",
                        marginRight: "2px",
                      }
                }
              >
                {transaction.currency}
              </span>
              <small style={{ fontSize: 10, marginRight: 3, paddingTop: 2 }}>
                (بالانس)
              </small>
            </span>
          </div>
        )}
        {/* order unique id */}
        {transaction?.order_unique_id &&
          transaction?.order_unique_id?.length > 0 && (
            <div>
              <span>
                <FaHashtag />
                {FormatHelper.toPersianString(transaction.order_unique_id)}
              </span>
            </div>
          )}
      </div>
    </div>
  );
};
export default TransactionactionCard;
